import { render, staticRenderFns } from "./CustomerShowPayment.vue?vue&type=template&id=7c0b995e"
import script from "./CustomerShowPayment.vue?vue&type=script&lang=js"
export * from "./CustomerShowPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports